import dayjs from 'dayjs';

export const MAINTENANCE = {
  isSet: () =>
    process.env.NEXT_PUBLIC_MAINTENANCE_START &&
    dayjs(process.env.NEXT_PUBLIC_MAINTENANCE_START).isValid(),
  isActive: () =>
    process.env.NEXT_PUBLIC_MAINTENANCE_START &&
    dayjs(process.env.NEXT_PUBLIC_MAINTENANCE_START).isValid() &&
    dayjs(process.env.NEXT_PUBLIC_MAINTENANCE_START).isBefore(dayjs()),
  /**
   * redirect interval should start 6 hours before the maintenance start
   * so that we catch all cached client views opened before the maintenance start
   */
  isClientSideIntervalRedirectActive: () =>
    process.env.NEXT_PUBLIC_MAINTENANCE_START &&
    dayjs(process.env.NEXT_PUBLIC_MAINTENANCE_START).isValid() &&
    dayjs(process.env.NEXT_PUBLIC_MAINTENANCE_START).isAfter(dayjs().subtract(6, 'hour')),
};
